export const PAUSE = 'CM PAUSE';
export const PAUSE_ON = { type: PAUSE, on: true };
export const PAUSE_OFF = { type: PAUSE, on: false };
export const SET_OVER = 'CM SET OVER';
export const SET_OVER_ON = { type: SET_OVER, over: true };
export const SET_OVER_OFF = { type: SET_OVER, over: false };
export const UPDATE_STATS = 'CM UPDATE STATS';
export const SET_SIZE = 'CM SET SIZE';
export const SET_CLEARED = 'CM SET CLEARED';
export const SET_BONUS = 'CM SET BONUS';
export const SET_SECS = 'CM SET SECS';

export const pause = on => ({ type: PAUSE, on });
